import { HttpStatusCode } from "../../../../common/infra/http-status/http-status";
import { BackedApi } from "../../../../config/urls/Api";
import { LoginModel } from "../../../../models/login.model";
interface ResponseLogin {
    authorized: boolean;
}

export class LoginRepository {
    static async login(login: LoginModel): Promise<ResponseLogin> {    
        try {
            const response = await this.sendRequest(
                BackedApi.Login.url,
                BackedApi.Login.method,
                login
            )                    
            return { authorized: response.status === HttpStatusCode.OK};
        } catch (error) {
            return { authorized: false };
        }
    }

    private static async sendRequest(url: string, method: string, body: any) {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(body)
        })
        return response;
    }
}